/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import React from "react"
import PropTypes from "prop-types"
import { jsx } from "theme-ui"

// Lägg till &h=DIN_TOKEN i slutet om filmen är unlisted på Vimeo
const VIMEO_SRC =
  "https://player.vimeo.com/video/1224660133?background=1&autoplay=1&loop=1&muted=1"

const Banner = ({ bgOverlay }) => {
  const bgOverlayStyles = bgOverlay
    ? {
        "&:after": {
          content: '""',
          position: "absolute",
          inset: 0,
          background: bgOverlay,
          pointerEvents: "none",
        },
      }
    : {}

  return (
    <div
      className="GtmBanner"
      sx={{
        variant: "components.banner",
        position: "relative",
        overflow: "hidden",
        width: "100%",
        containerType: "size",
        minHeight: 0,
        padding: 0,
        // Mobil och stående paddor: 4:5-crop
        aspectRatio: "4 / 5",
        height: "auto",
        // Från 768 px och uppåt: fullskärm
        "@media (min-width: 768px)": {
          aspectRatio: "auto",
          height: "90vh",
        },
        ...bgOverlayStyles,
      }}
    >
      <iframe
        title="vimeo-player"
        src={VIMEO_SRC}
        frameBorder="0"
        allow="autoplay; fullscreen"
        style={{
          position: "absolute",
          bottom: 0,
          left: "50%",
          transform: "translateX(-50%)",
          width: "max(111.11cqw, calc(111.11cqh * 16 / 9))",
          height: "max(111.11cqh, calc(111.11cqw * 9 / 16))",
          maxWidth: "none",
          maxHeight: "none",
          border: 0,
          pointerEvents: "none",
        }}
      />
    </div>
  )
}

Banner.propTypes = {
  bgOverlay: PropTypes.string,
}

export default Banner